import { useCallback, useState } from 'react';
import type { Chat } from '@trinity/chat';
import { ChatTabsContext } from './context';

type Props = {
  children: React.ReactNode;
};

export const ChatTabsContainer = (props: Props) => {
  const [index, setIndex] = useState(0);
  const [items, setItems] = useState<Chat.Instance[]>([]);

  const value = {
    index,
    setIndex,
    items,
    setItems,
  };

  return (
    <ChatTabsContext.Provider value={value}>
      {props.children}
    </ChatTabsContext.Provider>
  );
};

ChatTabsContainer.displayName = 'Chat.Tabs.Container';